import { defineMutators } from '@rocicorp/zero';
import { organisations } from './organisation.mutators.js';
export { AddOrganisationSchema, UpdateOrganisationSchema } from './organisation.mutators.js';
export { DeleteResourceSchema } from './util.js';
export const mutators = defineMutators({
    organisations,
});
//# sourceMappingURL=index.js.map